export default __webpack_public_path__ + "static/media/Facebook_messenger_ringtone.fae1e5a1.mp3";